var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_1903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 35.9791 8.7765 45.908 20.25 47.7084V30.9375H14.1562V24H20.25V18.7125C20.25 12.6975 23.833 9.375 29.3152 9.375C31.941 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6612C28.6798 15.75 27.75 17.6 27.75 19.4979V24H34.4062L33.3422 30.9375H27.75V47.7084C39.2236 45.908 48 35.9791 48 24Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3422 30.9375L34.4062 24H27.75V19.4979C27.75 17.6 28.6797 15.75 31.6612 15.75H34.6875V9.84375C34.6875 9.84375 31.9409 9.375 29.3152 9.375C23.833 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7084C21.4718 47.9002 22.7242 48 24 48C25.2758 48 26.5281 47.9002 27.75 47.7084V30.9375H33.3422Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.15236837964dd66a25399ddb0af6cdc7.svg";
export { ForwardRef as ReactComponent };